<div class="carousel-dots"
     [class.ng-hide]="(bullets && bullets.length || 0) <= 1"
     [style.--carousel-dots-number]="bullets.length"
     *ngIf="swiper">
    <div class="carousel-dots-inner"
         aria-label="Carousel Pagination">
        <ng-container *ngFor="let bullet of $any(bullets); let i = index; trackBy: trackByIndex">
            <button class="carousel-dot"
                    [class.is-active]="index === i"
                    type="button"
                    [attr.aria-label]="'Carousel Page ' + (i + 1) + (index === i ? ' (Current Slide)' : '')"
                    (click)="slideTo(i)"></button>
        </ng-container>
        <div class="carousel-dots-underbar"></div>
    </div>
</div>

<!-- hide swiper pagination -->
<div class="ng-hide"
     [ngClass]="paginationClass || ''"></div>